// Getters
import { sortByDate } from '@utils/Sort'

export const dataReferencia = (state) => {
  return state.dataReferencia
}

export const ultimoProfissionalFiltrado = (state) => {
  return state.ultimoProfissionalFiltrado
}

export const advisorComissoes = (state) => {
  return state.advisorCommissions.data || []
}
export const advisorComissoesSummary = (state) => {
  return state.advisorCommissions.summary || {}
}
export const advisorComissoesVisibleValues = (state) => {
  return state.advisorCommissions.visibleValues
}
export const advisorComissoesLoading = (state) => {
  return state.advisorCommissions.loading
}
export const advisorComissoesLastUpdate = (state) => {
  return state.advisorCommissions.lastUpdate
}
export const rules = (state) => {
  return state.rules.data || []
}
export const rulesLoading = (state) => {
  return state.rules.loading
}
export const rulesLastUpdate = (state) => {
  return state.rules.lastUpdate
}

// Getters
export const spreadsSheet = (state) => {
  return state.spreadsSheet.data || []
}
export const spreadsSheetLoading = (state) => {
  return state.spreadsSheet.loading
}
export const spreadsSheetLastUpdate = (state) => {
  return state.spreadsSheet.lastUpdate
}

export const brokers = (state) => {
  return state.brokers.data || []
}
export const brokersLoading = (state) => {
  return state.brokers.loading
}
export const brokersLastUpdate = (state) => {
  return state.brokers.lastUpdate
}

export const sheetTypes = (state) => {
  return state.sheetTypes.data || []
}
export const sheetTypesLoading = (state) => {
  return state.sheetTypes.loading
}
export const sheetTypesLastUpdate = (state) => {
  return state.sheetTypes.lastUpdate
}

export const sheetModels = (state) => {
  return state.sheetModels.data || []
}
export const sheetModelsLoading = (state) => {
  return state.sheetModels.loading
}
export const sheetModelsLastUpdate = (state) => {
  return state.sheetModels.lastUpdate
}

export const payments = (state) => {
  return state.payments.data || []
}
export const paymentsDate = (state) => {
  if (state.payments.data) {
    return state.payments.data.data_referencia || ''
  }
  return ''
}
export const paymentsList = (state) => {
  if (state.payments.data && state.payments.data.data) {
    return state.payments.data.data || []
  }
}
export const paymentsGroups = (state) => {
  if (state.payments.data && state.payments.data.data) {
    return state.payments.data.grupos || []
  }
}
export const paymentsLoading = (state) => {
  return state.payments.loading
}
export const paymentsLastUpdate = (state) => {
  return state.payments.lastUpdate
}

export const paymentsGroupsList = (state) => {
  return state.paymentsGroups.data || []
}
export const paymentsGroupsLoading = (state) => {
  return state.paymentsGroups.loading
}
export const paymentsGroupsLastUpdate = (state) => {
  return state.paymentsGroups.lastUpdate
}
export const paymentsGroupsRefDate = (state) => {
  return state.paymentsGroups.refDate || null
}
export const paymentGroupNames = (state) => {
  return state.paymentGroupNames.data || []
}
export const paymentGroupNamesLoading = (state) => {
  return state.paymentGroupNames.loading
}
export const paymentGroupNamesLastUpdate = (state) => {
  return state.paymentGroupNames.lastUpdate
}

export const tax = (state) => {
  return state.tax.data || []
}
export const taxLoading = (state) => {
  return state.tax.loading
}
export const taxLastUpdate = (state) => {
  return state.tax.lastUpdate
}

export const lists = (state) => {
  return state.lists.data || []
}
export const listsAudit = (state) => {
  return state.lists.audit || {}
}
export const listsLoading = (state) => {
  return state.lists.loading
}
export const listsLastUpdate = (state) => {
  return state.lists.lastUpdate
}
export const fechamentos = (state) => {
  return state.fechamentos.data || []
}
export const fechamentoRecente = (state) => {
  return (
    sortByDate({
      items: JSON.parse(JSON.stringify(state.fechamentos.data || [])),
      key: 'data_referencia',
    })[0] || {}
  )
}
export const fechamentosLoading = (state) => {
  return state.fechamentos.loading
}
export const fechamentosLastUpdate = (state) => {
  return state.fechamentos.lastUpdate
}

export const filterOptions = (state) => {
  return state.filterOptions.data || {}
}
export const filterOptionsLoading = (state) => {
  return state.filterOptions.loading
}
export const filterOptionsLastUpdate = (state) => {
  return state.filterOptions.lastUpdate
}

export const minimoGarantido = (state) => {
  return state.minimoGarantido.data || []
}
export const minimoGarantidoLoading = (state) => {
  return state.minimoGarantido.loading
}
export const minimoGarantidoLastUpdate = (state) => {
  return state.minimoGarantido.lastUpdate
}

export const manualAdjustments = (state) => {
  return state.manualAdjustments.data || []
}
export const manualAdjustmentsLoading = (state) => {
  return state.manualAdjustments.loading
}
export const manualAdjustmentsLastUpdate = (state) => {
  return state.manualAdjustments.lastUpdate
}

export const fieldChange = (state) => {
  return state.fieldChange.data || []
}
export const fieldChangeLoading = (state) => {
  return state.fieldChange.loading
}
export const fieldChangeLastUpdate = (state) => {
  return state.fieldChange.lastUpdate
}

export const filterOptionsRules = (state) => {
  return state.filterOptionsRules.data || []
}
export const filterOptionsRulesLoading = (state) => {
  return state.filterOptionsRules.loading
}
export const filterOptionsRulesLastUpdate = (state) => {
  return state.filterOptionsRules.lastUpdate
}

export const filterOptionsTransformed = (state) => {
  const data = state.filterOptions.data || {}
  const result = {}
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      result[key] = value.map((item) => ({
        text: item.nome,
        value: item.id,
      }))
    } else {
      result[key] = value
    }
  }
  return result
}

export const aprovacaoProfissional = (state) => {
  return state.aprovacaoProfissional.data || []
}
export const aprovacaoProfissionalLoading = (state) => {
  return state.aprovacaoProfissional.loading
}
export const aprovacaoProfissionalLastUpdate = (state) => {
  return state.aprovacaoProfissional.lastUpdate
}
export const summaryOverview = (state) => {
  return state.summaryOverview.data || []
}
export const summaryOverviewLoading = (state) => {
  return state.summaryOverview.loading
}
export const summaryOverviewLastUpdate = (state) => {
  return state.summaryOverview.lastUpdate
}

export const revenueHistory = (state) => {
  return state.revenueHistory.data || []
}
export const revenueHistoryLoading = (state) => {
  return state.revenueHistory.loading
}
export const revenueHistoryLastUpdate = (state) => {
  return state.revenueHistory.lastUpdate
}

export const commissions = (state) => {
  return state.commissions.data || []
}
export const commissionsLoading = (state) => {
  return state.commissions.loading
}
export const commissionsLastUpdate = (state) => {
  return state.commissions.lastUpdate
}

export const commissionsDetails = (state) => {
  return state.commissionsDetails.data || []
}
export const commissionsDetailsLoading = (state) => {
  return state.commissionsDetails.loading
}
export const commissionsDetailsLastUpdate = (state) => {
  return state.commissionsDetails.lastUpdate
}

export const revenueOverview = (state) => {
  return state.revenueOverview.data || []
}
export const revenueOverviewLoading = (state) => {
  return state.revenueOverview.loading
}
export const revenueOverviewLastUpdate = (state) => {
  return state.revenueOverview.lastUpdate
}

export const revenueOverviewDetails = (state) => {
  return state.revenueOverviewDetails.data || []
}
export const revenueOverviewDetailsLoading = (state) => {
  return state.revenueOverviewDetails.loading
}
export const revenueOverviewDetailsLastUpdate = (state) => {
  return state.revenueOverviewDetails.lastUpdate
}

export const generalData = (state) => {
  return state.generalData.data || []
}
export const roaData = (state) => {
  return state.roaData.data || { metadata: null, total: null, itens: [] }
}
export const roaDataLoading = (state) => {
  return state.roaData.loading
}
export const roaCompetencias = (state) => {
  return state.roaCompetencias.data || []
}
export const roaCompetenciasLoading = (state) => {
  return state.roaCompetencias.loading
}
export const roaCompetenciasLastUpdate = (state) => {
  return state.roaCompetencias.lastUpdate
}
export const generalDataLoading = (state) => {
  return state.generalData.loading
}
export const generalDataLastUpdate = (state) => {
  return state.generalData.lastUpdate
}

export const clientAnalysis = (state) => {
  return state.clientAnalysis.data || []
}
export const clientAnalysisLoading = (state) => {
  return state.clientAnalysis.loading
}
export const clientAnalysisLastUpdate = (state) => {
  return state.clientAnalysis.lastUpdate
}

export const resultsByAdvisor = (state) => {
  return state.resultsByAdvisor.data || {}
}
export const resultsByAdvisorLoading = (state) => {
  return state.resultsByAdvisor.loading
}
export const resultsByAdvisorLastUpdate = (state) => {
  return state.resultsByAdvisor.lastUpdate
}

export const resultsByCategories = (state) => {
  return state.resultsByCategories.data || []
}
export const resultsByCategoriesLoading = (state) => {
  return state.resultsByCategories.loading
}
export const resultsByCategoriesLastUpdate = (state) => {
  return state.resultsByCategories.lastUpdate
}

export const comentarios = (state) => {
  return state.comentarios.data || []
}
export const comentariosLoading = (state) => {
  return state.comentarios.loading
}
export const comentariosLastUpdate = (state) => {
  return state.comentarios.lastUpdate
}

export const selectedFilters = (state) => {
  return state.selectedFilters || {}
}
export const selectedFiltersLoading = (state) => {
  return state.selectedFilters.loading
}
export const selectedFiltersLastUpdate = (state) => {
  return state.selectedFilters.lastUpdate
}
export const exportPayments = (state) => {
  return state.exportPayments.data || []
}
export const exportPaymentsLoading = (state) => {
  return state.exportPayments.loading
}
export const exportPaymentsLastUpdate = (state) => {
  return state.exportPayments.lastUpdate
}

export const dadosIndicadores = (state) => {
  return state.dadosIndicadores.data || []
}
export const dadosIndicadoresLoading = (state) => {
  return state.dadosIndicadores.loading
}
export const dadosIndicadoresLastUpdate = (state) => {
  return state.dadosIndicadores.lastUpdate
}
export const dadosIndicadoresResumo = (state) => {
  return (state.dadosIndicadores.data || {}).resumo || {}
}
export const dadosIndicadoresHistoricoReceita = (state) => {
  return (state.dadosIndicadores.data || {})['historico-de-receita'] || {}
}
export const dadosIndicadoresDadosGerais = (state) => {
  return (state.dadosIndicadores.data || {})['dados-gerais'] || {}
}
export const dadosIndicadoresGraficoComissoes = (state) => {
  return (state.dadosIndicadores.data || {})['grafico-comissoes'] || {}
}
export const dadosIndicadoresGraficoReceita = (state) => {
  return (state.dadosIndicadores.data || {})['grafico-receita'] || {}
}
export const dadosIndicadoresResultadoAssessor = (state) => {
  return (state.dadosIndicadores.data || {})['resultado-por-assessor'] || {}
}
export const dadosIndicadoresResultadoCampo = (state) => {
  return (
    (state.dadosIndicadores.data || {})['resultado-por-determinado-campo'] || {}
  )
}
export const dadosProfissionais = (state) => {
  return state.dadosProfissionais.data || {}
}
export const dadosProfissionaisLoading = (state) => {
  return state.dadosProfissionais.loading
}
export const dadosProfissionaisLastUpdate = (state) => {
  return state.dadosProfissionais.lastUpdate
}
export const dadosProfissionaisFilters = (state) => {
  return state.dadosProfissionais.data.filtros
}

export const dadosProfissionaisGraficoComissoes = (state) => {
  return (state.dadosProfissionais.data || {})['grafico-comissoes'] || {}
}
export const dadosProfissionaisDetalhamentoComissoes = (state) => {
  return (
    (state.dadosProfissionais.data || {})['detalhamento-de-comissoes'] || []
  )
}
export const dadosProfissionaisGraficoReceita = (state) => {
  return (state.dadosProfissionais.data || {})['grafico-receita'] || {}
}
export const dadosProfissionaisDetalhamentoReceita = (state) => {
  return (state.dadosProfissionais.data || {})['detalhamento-de-receita'] || {}
}
export const dadosProfissionaisResultadoCampo = (state) => {
  return (
    (state.dadosProfissionais.data || {})['resultado-por-determinado-campo'] ||
    {}
  )
}
export const dadosCategorias = (state) => {
  return state.dadosCategorias.data || []
}
export const dadosCategoriasLoading = (state) => {
  return state.dadosCategorias.loading
}
export const dadosCategoriasLastUpdate = (state) => {
  return state.dadosCategorias.lastUpdate
}
export const dadosCategoriasFilters = (state) => {
  return state.dadosCategorias.data.filtros
}
export const dadosCategoriasAnaliseCliente = (state) => {
  return (state.dadosCategorias.data || {})['analise-por-cliente'] || {}
}
export const dadosCategoriasDetalhamentoReceita = (state) => {
  return (state.dadosCategorias.data || {})['detalhamento-de-receita'] || {}
}
export const dadosCategoriasGraficoReceita = (state) => {
  return (state.dadosCategorias.data || {})['grafico-receita'] || {}
}
export const dadosCategoriasResultadoPorDeterminadoCampo = (state) => {
  return (
    (state.dadosCategorias.data || {})['resultado-por-determinado-campo'] || {}
  )
}
export const referenceBase = (state) => {
  return state.referenceBase.data || []
}
export const referenceBaseLoading = (state) => {
  return state.referenceBase.loading
}
export const referenceBaseLastUpdate = (state) => {
  return state.referenceBase.lastUpdate
}

export const localFilters = (state) => {
  return state.localFilters.data || {}
}

export const baseClientes = (state) => {
  return state.baseClientes.data || []
}
export const baseClientesLoading = (state) => {
  return state.baseClientes.loading
}
export const baseClientesLastUpdate = (state) => {
  return state.baseClientes.lastUpdate
}
export const gatilhosPerformance = (state) => {
  return state.gatilhosPerformance.data || {}
}
export const gatilhosPerformanceLoading = (state) => {
  return state.gatilhosPerformance.loading
}
export const gatilhosPerformanceLastUpdate = (state) => {
  return state.gatilhosPerformance.lastUpdate
}
export const gatilhosIndicadores = (state) => {
  return state.gatilhosIndicadores.data || []
}
export const gatilhosIndicadoresLoading = (state) => {
  return state.gatilhosIndicadores.loading
}
export const gatilhosIndicadoresLastUpdate = (state) => {
  return state.gatilhosIndicadores.lastUpdate
}
export const gatilhosIndicadoresResultados = (state) => {
  const resultados = state.gatilhosIndicadores && state.gatilhosIndicadores.resultados
  return Array.isArray(resultados) ? resultados : []
}
